/**
 * Checks if an answers object/array contains any non-empty values.
 * Handles nested objects and arrays recursively.
 *
 * @param {Object|Array|*} answers - The answers to check (can be object, array, or nested)
 * @returns {boolean} - True if there are any non-empty values
 */
const hasNonEmptyAnswers = (answers) => {
  if (answers === null || answers === undefined || answers === '') {
    return false;
  }

  if (Array.isArray(answers)) {
    return answers.some(item => {
      if (item !== null && item !== undefined && item !== '') {
        if (typeof item === 'object') {
          return hasNonEmptyAnswers(item);
        }
        return true;
      }
      return false;
    });
  }

  if (typeof answers === 'object') {
    return Object.values(answers).some(value => {
      if (value !== null && value !== undefined && value !== '') {
        if (typeof value === 'object') {
          return hasNonEmptyAnswers(value);
        }
        return true;
      }
      return false;
    });
  }

  return answers !== null && answers !== undefined && answers !== '';
};

export default hasNonEmptyAnswers;
